// extracted by mini-css-extract-plugin
export default {"container":"B7-z","creativeContainer":"C7-z","copy":"D7-z","cta":"E7-z","disabled":"F7-z","flipped":"G7-z","productCard":"H7-z"};